<template>
  <div class="customer-search-bar">
    <div style="margin:4px">
      <el-button type="primary" icon="el-icon-plus" @click="newCompany">New Company</el-button>
    </div>
    <div style="margin-top:20px;text-align:center;">
      <el-button type="primary" @click="search">Search</el-button>
      <el-button type="primary" style="margin-left:2px;" @click="reset">Reset</el-button>
    </div>
    <div style="padding:4px;">
      Company<br/>
      <el-input v-model="form.query"></el-input><br/>
      Contact Person<br/>
      <el-input v-model="form.contact_name"></el-input><br/>
      Tel. no<br/>
      <el-input v-model="form.phone"></el-input><br/>
      Fax. no<br/>
      <el-input v-model="form.fax"></el-input><br/>
      Email<br/>
      <el-input v-model="form.email"></el-input><br/>
      Country<br/>
      <el-select v-model="form.country" filterable>
        <el-option label="All" value="all"></el-option>
        <el-option v-for="item in countries" :key="item.en" :label="item.en" :value="item.en"></el-option>  
      </el-select><br/>
      Sales<br/>
      <el-select v-model="form.sales_id">
        <el-option label="All" value="all"></el-option>
        <el-option v-for="item in salesList" :key="item.id" :label="item.realname" :value="item.id"></el-option>  
      </el-select><br/>
      Trade/Factory<br/>
      <el-select v-model="form.type_1">
        <el-option label="All" value="all"></el-option>
        <el-option label="Trade" value="Trade"></el-option>
        <el-option label="Factory" value="Factory"></el-option> 
      </el-select><br/>
      Supplier/Buyer<br/>
      <el-select v-model="form.type_2">
        <el-option label="All" value="all"></el-option>
        <el-option label="Supplier" value="Supplier"></el-option>
        <el-option label="Buyer" value="Buyer"></el-option> 
      </el-select><br/>
      Grade<br/>
      <el-select v-model="form.grade">
        <el-option label="All" value="all"></el-option>
        <el-option label="5" value="5"></el-option>
        <el-option label="4+" value="4+"></el-option>
        <el-option label="3+" value="3+"></el-option>
        <el-option label="2+" value="2+"></el-option>
        <el-option label="1+" value="1+"></el-option>
        <el-option label="0+" value="0+"></el-option>
        <el-option label="4" value="4"></el-option>
        <el-option label="3" value="3"></el-option>
        <el-option label="2" value="2"></el-option>
        <el-option label="1" value="1"></el-option>
        <el-option label="0" value="0"></el-option>
        <el-option label="-1" value="-1"></el-option>
        <el-option label="-2" value="-2"></el-option>
        <el-option label="-1&amp;-2" value="-1&amp;-2"></el-option>
      </el-select><br/>
      Start sort<br/>
      <el-select v-model="form.order_by">
        <el-option label="From First" value="asc"></el-option>
        <el-option label="From Last" value="desc"></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      defaultForm: {
        query: '',
        contact_name: '',
        phone: '',
        fax: '',
        email: '',
        country: 'all',
        sales_id: 'all',
        type_1: 'all',
        type_2: 'all',
        grade: 'all',
        order_by: 'asc'
      },
      form: {
        query: '',
        contact_name: '',
        phone: '',
        fax: '',
        email: '',
        country: 'all',
        sales_id: 'all',
        type_1: 'all',
        type_2: 'all',
        grade: 'all',
        order_by: 'asc'
      }
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    countries () {
      return this.$store.state.select.countries
    },
    salesList () {
      return this.$store.state.select.sales
    }
  },
  mounted () {
    this.$store.dispatch('fetchSelect', 'sales')
    this.$store.dispatch('fetchSelect', 'countries')
  },
  methods: {
    newCompany () {
      this.$router.push('/customer/company/edit/new')
    },
    search () {
      let params = { ...this.form }
      if (params.query === '') {
        delete params.query
      }
      if (params.contact_name === '') {
        delete params.contact_name
      }
      if (params.phone === '') {
        delete params.phone
      }
      if (params.fax === '') {
        delete params.fax
      }
      if (params.email === '') {
        delete params.email
      }
      if (params.country === 'all') {
        delete params.country
      }
      if (params.sales_id === 'all') {
        delete params.sales_id
      }
      if (params.type_1 === 'all') {
        delete params.type_1
      }
      if (params.type_2 === 'all') {
        delete params.type_2
      }
      if (params.grade === 'all') {
        delete params.grade
      } else if (params.grade.indexOf('+') > 0) {
        params.grade_ge = params.grade.substr(0, 1)
        delete params.grade
      } else if (params.grade === '-1&-2') {
        params.grade_lt = 0
        delete params.grade
      }
      if (this.user.role_id >= 3) { // 普通员工只能搜自己的客户(只搜索名字时除外)
        if (params.contact_name || params.phone || params.fax || params.email 
        || params.country || params.sales_id || params.type_1 || params.type_2 
        || params.grade || params.grade_ge || params.grade_lt) {
          this.form.sales_id = this.user.id
          params.sales_id = this.user.id
        }
      }
      this.$emit('search', params)
    },
    reset () {
      this.form = { ...this.defaultForm }
    }
  }
}
</script>

<style>
.customer-search-bar {
  font-size:12px;
}
</style>